export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    accountNumber = "",
    entityName = "",
    currency = "VNĐ",
    openingBalance = { debit: 0, credit: 0 },
    details = [],
    totalIncurred = { debit: 0, credit: 0 },
    closingBalance = { debit: 0, credit: 0 },
    totalPages = "1",
    openingDate = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
    signingDay = "",
    signingMonth = "",
    signingYear = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let rowsHtml = "";

  // Opening Balance Row
  rowsHtml += `
    <tr style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">Số dư đầu kỳ</td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border text-right px-1">${fmt(openingBalance.debit)}</td>
      <td class="border text-right px-1">${fmt(openingBalance.credit)}</td>
    </tr>
  `;

  // details
  details.forEach((item) => {
    rowsHtml += `
      <tr>
        <td class="border text-center">${item.bookingDate || ""}</td>
        <td class="border text-center">${item.documentNumber || ""}</td>
        <td class="border text-center">${item.documentDate || ""}</td>
        <td class="border px-1">${item.description || ""}</td>
        <td class="border text-center">${item.correspondingAccount || ""}</td>
        <td class="border text-right px-1">${fmt(item.debitIncurred)}</td>
        <td class="border text-right px-1">${fmt(item.creditIncurred)}</td>
        <td class="border text-right px-1">${fmt(item.debitBalance)}</td>
        <td class="border text-right px-1">${fmt(item.creditBalance)}</td>
      </tr>
    `;
  });

  // Total Incurred
  rowsHtml += `
    <tr bgcolor="#FDFDFD" style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">Cộng số phát sinh</td>
      <td class="border text-center">x</td>
      <td class="border text-right px-1">${fmt(totalIncurred.debit)}</td>
      <td class="border text-right px-1">${fmt(totalIncurred.credit)}</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
    </tr>
  `;

  // Closing Balance
  rowsHtml += `
    <tr bgcolor="#FAFAFA" style="font-weight: bold;">
      <td class="border"></td>
      <td class="border"></td>
      <td class="border"></td>
      <td class="border px-1">Số dư cuối kỳ</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-center">x</td>
      <td class="border text-right px-1">${fmt(closingBalance.debit)}</td>
      <td class="border text-right px-1">${fmt(closingBalance.credit)}</td>
    </tr>
  `;

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.4;">
      <table width="100%">
        <tr>
          <td width="60%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="40%" align="center">
            <div class="font-bold">Mẫu số S38-DN</div>
            <div style="font-style: italic; font-size: 11px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 20px 0;">
        <h2 style="margin: 0; text-transform: uppercase;">SỔ CHI TIẾT CÁC TÀI KHOẢN</h2>
        <div style="font-style: italic; font-size: 11px;">(Dùng cho các TK: 136, 138, 141, 157, 171, 221, 222, 242, 244, 333, 334, 335, 336, 337, 338, 344, 352, 353, 356, 411, 421,...)</div>
        
        <div style="margin-top: 15px;">Tài khoản: <span style="border-bottom: 1px dotted black; padding: 0 20px; font-weight: bold;">${accountNumber}</span></div>
        <div style="margin-top: 5px;">Đối tượng: <span style="border-bottom: 1px dotted black; padding: 0 40px; font-weight: bold;">${entityName}</span></div>
        <div style="margin-top: 5px; font-style: italic;">Loại tiền: <span style="border-bottom: 1px dotted black; padding: 0 15px;">${currency}</span></div>
      </div>

      <table width="100%" style="border-collapse: collapse; margin-top: 20px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="70">Ngày, tháng ghi sổ</th>
            <th class="border" colspan="2">Chứng từ</th>
            <th class="border" rowspan="2">Diễn giải</th>
            <th class="border" rowspan="2" width="60">TK đối ứng</th>
            <th class="border" colspan="2">Số phát sinh</th>
            <th class="border" colspan="2">Số dư</th>
          </tr>
          <tr>
            <th class="border" width="70">Số hiệu</th>
            <th class="border" width="70">Ngày tháng</th>
            <th class="border" width="90">Nợ</th>
            <th class="border" width="90">Có</th>
            <th class="border" width="90">Nợ</th>
            <th class="border" width="90">Có</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">C</th>
            <th class="border">D</th>
            <th class="border">E</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">4</th>
          </tr>
        </thead>
        <tbody>
          ${rowsHtml}
        </tbody>
      </table>

      <div style="margin-top: 25px;">
        <div style="margin-bottom: 5px;">- Sổ này có <span style="border-bottom: 1px dotted black; padding: 0 10px;">${totalPages}</span> trang, đánh số từ trang 01 đến trang...</div>
        <div>- Ngày mở sổ: <span style="border-bottom: 1px dotted black; padding: 0 10px;">${openingDate}</span></div>
      </div>

      <table width="100%" style="margin-top: 40px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 80px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 11px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 80px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>
    </div>

    <style>
      .border { border: 1px solid black; }
      .text-center { text-align: center; }
      .text-right { text-align: right; }
      .font-bold { font-weight: bold; }
      .px-1 { padding: 0 4px; }
    </style>
  `;
};
